<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	// Services
	import { format } from 'svelte-i18n';
	// Design system components
	import { Text } from '@Shelly/shelly-design-system';
	// Components
	import Chart from './Chart.svelte';
	import type { ChartDataInterface, ChartInterface, TimeZoneInterface } from '../../types/Chart';
	import { removeOrAddUnderscore } from 'src/helpers/utilities';
	import { isDistance, real_id } from 'src/helpers/interface_helpers';
	import { devices } from 'src/stores/lists/devices';
	import { DISTANCE_BASE_SIZE } from 'src/helpers/distance_helper';

	$: settingsStore = getDeviceSettings(device.id);
	export let chartData: ChartDataInterface,
		deviceCategory: string = '',
		timeZone: TimeZoneInterface = null;

	let chartElement: Chart;
	export const getChartUtil = (): ChartInterface => {
		return chartElement.getChartUtil();
	};

	const device = $devices[chartData?.deviceID];

	if (isDistance(chartData?.deviceType)) {
		const distanceUnit =
			device?.ht_ui?.unit || $settingsStore?.ht_ui?.unit || 'mm';
		chartData.units = distanceUnit === 'in' ? 'in' : 'mm';
		if (device?.measureFromBase) {
			chartData.series.forEach((serie) => {
				serie.data.forEach((point) => {
					if (point.value > 0) {
						point.value += DISTANCE_BASE_SIZE;
					}
				});
			});
		}
	}
</script>

<Chart bind:this={chartElement} {chartData} on:change />
{#if timeZone?.tz}
	<Text size="xs" class="mt-s tiny-styles text-center text-secondary" style="user-select: none;"
		>{$format('local_time_zone', {
			values: {
				this_shelly_category: $format(
					`this_${deviceCategory == 'thermostat' ? 'sensor' : deviceCategory}`,
					{
						default: deviceCategory,
					},
				),
			},
			default: `Local time-zone of ${$format(
				`this_${deviceCategory == 'thermostat' ? 'sensor' : deviceCategory}`,
				{ default: deviceCategory },
			)}`,
		})}: {removeOrAddUnderscore(timeZone.tz, 'removeUnderscore')}
		{#if timeZone.timeZoneOffset != 0}
			{`${timeZone.time} (${timeZone.timeZoneOffset > 0 ? '+' : ''}${timeZone.timeZoneOffset}${$format(
				'local_time_zone_from_current_time_zone',
				{
					default: 'h from current time zone',
				},
			)})`}
		{/if}
	</Text>
{/if}
